module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-02-c76ae34a41b2e0532c2ab3852d14d43b.jpg";